module.exports = "fonts/playfair-display-v15-latin-regular.woff2";